var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRoundPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.75C1.49989 14.7796 1.73514 13.8237 2.18556 12.9643C2.63598 12.1048 3.28814 11.3673 4.08612 10.8152C4.88409 10.2631 5.80407 9.91278 6.76716 9.79426C7.73025 9.67574 8.70772 9.79258 9.61575 10.1347M16.0335 12.4695C16.3323 12.1707 16.5001 11.7655 16.5001 11.343C16.5001 10.9205 16.3323 10.5153 16.0335 10.2165C15.7347 9.91773 15.3295 9.74989 14.907 9.74989C14.4845 9.74989 14.0793 9.91773 13.7805 10.2165L10.773 13.2255C10.5947 13.4037 10.4642 13.624 10.3935 13.866L9.76575 16.0185C9.74693 16.083 9.7458 16.1514 9.76248 16.2166C9.77917 16.2817 9.81305 16.3411 9.86058 16.3887C9.90812 16.4362 9.96756 16.4701 10.0327 16.4868C10.0978 16.5035 10.1662 16.5023 10.2307 16.4835L12.3832 15.8558C12.6252 15.7851 12.8455 15.6546 13.0237 15.4763L16.0335 12.4695ZM11.25 6C11.25 8.07107 9.57107 9.75 7.5 9.75C5.42893 9.75 3.75 8.07107 3.75 6C3.75 3.92893 5.42893 2.25 7.5 2.25C9.57107 2.25 11.25 3.92893 11.25 6Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoundPen);
export default __webpack_public_path__ + "static/media/user-round-pen.f68e5080dbecf4b698efeb86bffdcce8.svg";
export { ForwardRef as ReactComponent };